import React, { createContext, useState, useEffect } from 'react';
import { auth } from "../lib/firebaseConfig";
import { onAuthStateChanged, User } from "firebase/auth";

type AuthContextType = {
  loading: boolean;
  user: User | null;
  setUser: React.Dispatch<React.SetStateAction<User | null>>;
};

export const AuthContext = createContext<AuthContextType | null>(null);

type ProviderProps = {
  children: React.ReactNode
}

const AuthProvider = ({ children }: ProviderProps) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);
  console.log('user', user);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setUser(user);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [auth]);

  return <AuthContext.Provider value={{ loading, user, setUser }}>{children}</AuthContext.Provider>;
};

export default AuthProvider;